<template>
    <div class="quiz-menu">
        <div class="quiz-menu__header tw:font-bold!">Quick Navigation</div>

        <ul>
            <li v-for="item in questions" :key="item.display_order" class="quiz-menu__item">
                <a @click="open(item.display_order)" @keyup="open(item.display_order)">
                    Question {{ Number(item.display_order) + 1 }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'QuizMenu',

    props: {
        uuid: {
            required: true,
            type: [String, Number],
        },
    },

    computed: {
        questions() {
            return this.$store.getters[`QuizBuilder/${this.uuid}/get`]('questions');
        },
    },

    methods: {
        get(field, order) {
            return this.$store.getters[`QuizBuilder/${this.uuid}/question`]({
                order,
                field,
            });
        },

        open(order) {
            this.$store.dispatch(`QuizBuilder/${this.uuid}/setQuestionField`, {
                field: 'expanded',
                order,
                value: true,
            });

            this.$nextTick(() => {
                const element = document.getElementById(`Question-${order}`);

                if (!element) {
                    return;
                }

                const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

                element.scrollIntoView({
                    behavior: prefersReducedMotion ? 'auto' : 'smooth',
                    block: 'start',
                    inline: 'nearest',
                });
            });
        },
    },
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.quiz-menu {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;

    &__header {
        color: $text;
        flex: 0 0 auto;
        font-size: 0.9em !important;
        font-weight: $weight-semibold;
        letter-spacing: 0.05rem;
        line-height: 1.66667;
        padding: 0.375rem 0;
        text-transform: uppercase;
    }

    ul {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding-bottom: $size-4;
    }

    &__item {
        a {
            border-radius: 0;
            color: $text;
            cursor: pointer;
            display: block;
            padding: 0.375em 0;
        }
    }
}
</style>
